module.exports = __webpack_public_path__ + "img/hearscreen.7d23ed9c.png";